<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content class="mat-typography">
  <h3>{{ data.msg }}</h3>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button
    mat-raised-button
    [mat-dialog-close]="true"
    cdkFocusInitial
    color="save">Sim</button>
  <button mat-raised-button color="delete" mat-dialog-close [mat-dialog-close]="false">Não</button>
</mat-dialog-actions>
